var instances = new WeakMap();

export { instances as default };
